<template>
  <div>
    <h6
      style="font-weight: 400; margin: 0px !important; padding: 0px !important"
    >
      {{
        parseCurrency(
          parseFloat((data.FIYAT * data.vat) / 100) + parseFloat(data.FIYAT)
        )
      }}
    </h6>
  </div>
</template>
      <script>
export default {
  data() {
    return {
      VALUE: "",
      data: [],
    };
  },
  created() {
    this.data = this.params.data;
    this.VALUE = this.params.value;
  },
  methods: {
    parseCurrency(gelen) {
      var gelenfloat = parseFloat(gelen);
      return gelenfloat.toLocaleString("tr-TR", {
        style: "currency",
        currency: "TRY",
      });
    },
  },
};
</script>
      